import React from 'react';

// Four-petal dogwood blossom with notched petal tips
export const DogwoodIcon = ({ className = 'w-6 h-6' }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M12 10.5 C10.2 8.3 9.6 5.6 10.7 3.7 C11.1 3.1 11.5 3.3 12 4.1 C12.5 3.3 12.9 3.1 13.3 3.7 C14.4 5.6 13.8 8.3 12 10.5 Z" />
    <path d="M12 13.5 C10.2 15.7 9.6 18.4 10.7 20.3 C11.1 20.9 11.5 20.7 12 19.9 C12.5 20.7 12.9 20.9 13.3 20.3 C14.4 18.4 13.8 15.7 12 13.5 Z" />
    <path d="M10.5 12 C8.3 10.2 5.6 9.6 3.7 10.7 C3.1 11.1 3.3 11.5 4.1 12 C3.3 12.5 3.1 12.9 3.7 13.3 C5.6 14.4 8.3 13.8 10.5 12 Z" />
    <path d="M13.5 12 C15.7 10.2 18.4 9.6 20.3 10.7 C20.9 11.1 20.7 11.5 19.9 12 C20.7 12.5 20.9 12.9 20.3 13.3 C18.4 14.4 15.7 13.8 13.5 12 Z" />
    <circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none" />
  </svg>
);

export default DogwoodIcon;
